<template>
  <div class="home">
    <NavbarMain />
    <div class="container py-5">
      <div class="cart-container shadow p-5">
        <div class="d-flex justify-content-between">
          <h4>Detalles del carrito</h4>
        </div>
        <hr />
        <h5 class="text-center text-secondary" v-if="cartItems.length == 0">
          Aún no tienes productos en el carrito.
        </h5>
        <ItemCart
          v-for="item in cartItems"
          :key="item._id"
          :item="item"
          v-on:remove="removeItem"
          v-on:add="addItem"
        />
        <div class="text-right d-none" v-if="this.cart.items.length">
          <router-link to="/comprar"
            ><span class="btn btn-success"
              >Finalizar compra (SC$ {{ totalCart }})</span
            ></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarMain from "@/components/NavbarMain.vue";
import { mapState, mapMutations } from "vuex";
import Api from "../tools/Api2";
import ItemCart from "@/components/ItemCart.vue";
import { LC } from "../tools/exchange";

export default {
  name: "Cart",
  components: {
    NavbarMain,
    ItemCart,
  },
  data() {
    return {
      cartItems: [],
      localCurrency: null,
    };
  },
  computed: {
    ...mapState(["cart", "changes"]),
    totalCart() {
      if (!this.localCurrency) return 0;
      const reducer = (acc, item) => {
        let productPrice = this.localCurrency.localToSC({
          price: item.price,
          currency: item.currency,
        });
        return (
          acc + productPrice * item.amountInCart * (1 - item.discount / 100)
        );
      };
      return this.cartItems.reduce(reducer, 0).toFixed(2);
    },
  },
  methods: {
    ...mapMutations(["removeItemCart", "addItemCart"]),
    addItem(item) {
      if (item.amount) {
        this.addItemCart({ id: item.id, amount: item.amount });
        let i = this.cartItems.findIndex((x) => x._id == item.id);
        this.cartItems[i].amountInCart = item.amount;
      } else {
        this.removeItem(item.id);
      }
    },
    removeItem(id) {
      this.removeItemCart(id);
      this.cartItems = this.cartItems.filter((x) => x._id != id);
    },
  },
  created: function() {
    LC.new().then((localcurrency) => (this.localCurrency = localcurrency));
    this.cart.items.forEach((item) => {
      Api(item.kind)
        .get(item.id)
        .then((res) => {
          this.cartItems.push({
            ...res[item.kind],
            amountInCart: item.amount,
            image: res[item.kind].images[0],
            kind: item.kind,
            options: item.options,
          });
        });
    });
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: absolute;
}

.home {
  height: 100%;
}
</style>
